import { render, staticRenderFns } from "./TaskTag.vue?vue&type=template&id=6515ebcd&scoped=true"
import script from "./TaskTag.vue?vue&type=script&lang=js"
export * from "./TaskTag.vue?vue&type=script&lang=js"
import style0 from "./TaskTag.vue?vue&type=style&index=0&id=6515ebcd&prod&lang=scss"
import style1 from "./TaskTag.vue?vue&type=style&index=1&id=6515ebcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515ebcd",
  null
  
)

export default component.exports